import React from 'react';
import {Filter, FilterProps} from 'react-admin';

const QuellwerkFilter = (props: Omit<FilterProps, 'children'>) => (
    <Filter {...props}>
        <></>
    </Filter>
);

export default QuellwerkFilter;
